import { Button } from "@mui/material";
import styled from "styled-components";

export const Container = styled.form<{ $hasAreaDriverAssigned: boolean }>`
  background: ${({ theme }) => theme.palette.background.paper};
  width: 502px;
  border: ${({ theme, $hasAreaDriverAssigned }) =>
    $hasAreaDriverAssigned
      ? "none"
      : `4px solid ${theme.palette.primary.main}`};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: 25px;
  margin-top: 25px;
`;

export const Image = styled.img`
  margin-right: 15px;
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
`;

export const ActionContainer = styled(Button)`
  display: flex;
  align-items: center;
  transition: opacity 0.2s !important;

  &:hover {
    opacity: ${({ theme }) => theme.palette.action.hoverOpacity};
    background-color: transparent !important;
  }
`;

export const ActionsContainer = styled.div<{ editMode: boolean }>`
  margin-top: 35px;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: ${({ editMode }) =>
    editMode ? "space-between" : "flex-end"};
`;

export const ContainerDriverSelected = styled.div`
  display: flex;
  width: 160px;
  align-items: center;
  gap: 10px;
`;

export const ContainerDriver = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerSelected = styled.div`
  display: flex;
  width: 300px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  padding-bottom: 35px;
  justify-content: space-between;
  padding: 0 50px;
`;

export const ContainerDrive = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const ContainerText = styled.div`
  display: flex;
  margin-top: -3px;
  flex-direction: column;
  h6 {
    max-width: 170px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const ContainerAutoComplete = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const MapAreaEditColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const MapDriverSelectRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 8px;
`;

export const MapAreaButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
`;

export const ContainerButtonsDrive = styled.div`
  display: flex;
  gap: 10px;
`;

export const DriversListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DriverListRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.palette.divider};
  }

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  }
`;

export const DriverListRowText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MapAreaViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const InfoTooltipTrigger = styled.span`
  display: inline-flex;
  align-items: center;
`;
